import React from 'react';
import PropTypes from 'prop-types';
import PopUp from '@/components/Modal/PopUp';
import Bling from './Bling';
import './style';

const score = [
  '75',
  '60',
  '45',
  '30',
  '15',
  '90',
  '50',
];
const seniorRules = {
  [score[4]]: 1,
  [score[3]]: 2,
  [score[2]]: 3,
  [score[1]]: 4,
  [score[0]]: 5,
};
const juniorRules = {
  [score[6]]: 'good',
  [score[5]]: 'fantastic',
};
class Score extends React.PureComponent {
  static propTypes = {
    hide: PropTypes.func,
    isSenior: PropTypes.bool,
    num: PropTypes.number,
  };

  state = {
    result: null,
  }

  componentDidMount() {
    const { isSenior, num } = this.props;
    const rules = isSenior ? seniorRules : juniorRules;
    let result = isSenior ? 0 : 'try_harder';
    Object.keys(rules).map((val) => {
      if (num > parseInt(val, 10)) {
        result = rules[val];
      }
      return result;
    });
    this.setState({ result });
  }

  handleHideModal = (e) => {
    e.preventDefault();
    this.props.hide();
  };

  returnMedal = (num) => {
    const items = [];
    for (let i = 0; i < num; i += 1) {
      items.push(<div key={`medal${i}`} className={`medal${i + 1} `}><div className="bling"><Bling /></div></div>);
    }
    for (let i = 0; i < (5 - num); i += 1) {
      items.push(<div key={`medal${i + num}`} className={`medal${i + num + 1} empty`} />);
    }
    return items;
  }

  render() {
    const { isSenior } = this.props;
    return (
      <PopUp hide={this.handleHideModal}>
        <div className="score">
          {isSenior
            ? (
              <div className="score-wrapper">
                {this.returnMedal(parseInt(this.state.result, 10))}
                <div className="professor" />
              </div>
            )
            : <div className={`score-pic ${this.state.result}`} />
          }
          <div className={isSenior ? 'score-ok-btn' : 'score-btn'} onClick={this.handleHideModal}>{isSenior ? 'OK' : '好的'}</div>
        </div>
      </PopUp>
    );
  }
}

export default Score;
